"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, HostBinding, Input } from '@angular/core';
var ButtonComponent = (function () {
    function ButtonComponent() {
        this.buttonType = 'button';
        this.display = 'inline';
    }
    Object.defineProperty(ButtonComponent.prototype, "disabled", {
        get: function () {
            return !!this.attrDisabled;
        },
        set: function (value) {
            this.attrDisabled = value ? true : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonComponent.prototype, "submit", {
        set: function (value) {
            this.buttonType = value ? 'submit' : 'button';
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        HostBinding('attr.disabled'),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "attrDisabled", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ButtonComponent.prototype, "link", void 0);
    __decorate([
        HostBinding('attr.data-busy'),
        Input(),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "busy", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "queryParams", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "linkActive", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "linkActiveOptions", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ButtonComponent.prototype, "fragment", void 0);
    __decorate([
        HostBinding('attr.data-color'),
        Input(),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "color", void 0);
    __decorate([
        HostBinding('attr.data-display'),
        Input(),
        __metadata("design:type", String)
    ], ButtonComponent.prototype, "display", void 0);
    __decorate([
        HostBinding('attr.data-size'),
        Input(),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "size", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], ButtonComponent.prototype, "disabled", null);
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], ButtonComponent.prototype, "submit", null);
    ButtonComponent = __decorate([
        Component({
            selector: 'fl-button',
            template: "\n    <a\n      *ngIf=\"link\"\n      class=\"ButtonElement\"\n      [routerLink]=\"link\"\n      [routerLinkActive]=\"linkActive || ''\"\n      [routerLinkActiveOptions]=\"linkActiveOptions || { exact: false }\"\n      [queryParams]=\"queryParams\"\n      [fragment]=\"fragment\"\n      [attr.disabled]=\"(attrDisabled || busy ? true : undefined)\"\n      aria-live=\"assertive\">\n      <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n      <fl-spinner\n        *ngIf=\"busy\"\n        class=\"LoadingSpinner\"\n        [size]=\"'small'\"\n        [color]=\"'grey'\"\n      ></fl-spinner>\n    </a>\n\n    <button *ngIf=\"!link\"\n      class=\"ButtonElement\"\n      [type]=\"buttonType\"\n      [attr.disabled]=\"(attrDisabled || busy ? true : undefined)\"\n      aria-live=\"assertive\">\n        <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n        <fl-spinner\n          *ngIf=\"busy\"\n          class=\"LoadingSpinner\"\n          [size]=\"'small'\"\n          [color]=\"'grey'\"\n        ></fl-spinner>\n    </button>\n\n    <ng-template #content>\n      <ng-content></ng-content>\n    </ng-template>\n  ",
            styleUrls: ['./button.component.scss'],
        })
    ], ButtonComponent);
    return ButtonComponent;
}());
export { ButtonComponent };



// WEBPACK FOOTER //
// button.component.js